import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styled from "styled-components";
import { trackEvent } from "../../services/analytics";
import { revokeServerSession } from "../../services/revokeServerSession";
import { useAuth } from "../../utils/context";

const StyledBurger = styled.button`
  z-index: 100;
  overflow: hidden;
  position: relative;
  top: -4px;
  display: flex;
  margin: auto 10px;
  flex-direction: column;
  justify-content: space-around;
  width: 1.8rem;
  height: 1.6rem;
  opacity: 0.7;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 100;
  div:first-child {
    transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
  }

  div:nth-child(2) {
    opacity: ${({ open }) => (open ? "0" : "1")};
    transform: ${({ open }) => (open ? "translateX(0.5rem)" : "translateX(0)")};
  }

  div:nth-child(3) {
    transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
  }
  div {
    width: 1.5rem;
    height: 0.2rem;
    background: ${({ open }) => (open ? "#1404DA" : "#ffffff")};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    overflow: hidden;
    transform-origin: 1px;
  }
`;

const StyledMenu = styled.nav`
  overflow-y: auto;
  z-index: 99;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  display: ${({ open }) => (open ? "flex" : "none")};
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  width: 100vw;
  text-align: center;
  padding: 2rem;
  position: fixed;
  background: white;
  transition: transform 0.3s ease-in-out;

  a {
    text-align: center;
    font-size: 1rem;
    text-transform: uppercase;
    padding: 0.8rem 0;
    font-weight: bold;
    text-decoration: none;
    transition: color 0.3s linear;
    @media (max-width: 1086px) {
      font-size: 1.4rem;
      text-align: center;
      justify-content: center;
    }

    &:hover {
      color: #1404da;
    }
  }
`;

const BurgerAndMenu = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const [auth, setAuth] = useAuth();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const handleLogout = async () => {
    trackEvent({
      category: 'User/ Burger Menu',
      action: 'Logout',
      label: 'User Logged Out'
    });
    await revokeServerSession(auth?.accessToken);
    setAuth({
      ...auth,
      user: null,
      accessToken: "",
    });
    localStorage.removeItem("auth");
    setOpen(!open);
  };

  // useEffect(() => {
  //   if (open) {
  //     document.body.style.overflow = "hidden";
  //   } else {
  //     document.body.style.overflow = "auto";
  //   }
  // }, [open]);
  //   // const handleMenuClick = (destinationPage) => {
  //   //   trackEvent({
  //   //     category: 'Hamburger Menu',
  //   //     action: 'Menu Click',
  //   //     label: `Menu Clicked - Destination Page: ${destinationPage}`
  //   //   });
  //   //   setOpen(!open);
  //   // };

  const handleLinkClick = (destinationPage) => {
    setOpen(false);
    trackEvent({
      category: 'Hamburger Menu',
      action: 'Menu Click',
      label: `Menu Clicked - Destination Page: ${destinationPage}`
    });
    toggleBodyScroll(false);
  };
  const handleMenuClick = () => {
    setOpen(!open);
    toggleBodyScroll(!open);
  };
  const toggleBodyScroll = (disableScroll) => {
    const body = document.querySelector("body");
    if (disableScroll) {
      body.style.overflow = "hidden";
    } else {
      body.style.overflow = "auto";
    }
  };
  return (
    <>
      <StyledBurger open={open} onClick={() => handleMenuClick("Close Hamburger")}>
        <div />
        <div />
        <div />
      </StyledBurger>
      <StyledMenu open={open}>
        <NavLink className="text-[#1404DA] " to="/" onClick={() => handleLinkClick("Home")}>
          Home
        </NavLink>
        <NavLink
          className="text-[#1404DA] "
          to="/courses"
          onClick={() => handleLinkClick("Courses")}
        >
          Courses
        </NavLink>
        <NavLink
          className="text-[#1404DA]"
          to="/cuet-course-eligibility"
          onClick={() => handleLinkClick("Eligibility")}
        >
          Eligibility
        </NavLink>
        <NavLink
          className="text-[#1404DA]"
          to="/about"
          onClick={() => handleLinkClick("About")}
        >
          About
        </NavLink>
        <NavLink
          className="text-[#1404DA]"
          to="/syllabus"
          onClick={() => handleLinkClick("Syllabus")}
        >
          Syllabus
        </NavLink>
        <NavLink
          className="text-[#1404DA]"
          to="/Blogs"
          onClick={() => handleLinkClick("Blogs")}
        >
          Blogs
        </NavLink>
        <NavLink
          className="text-[#1404DA]"
          to="/purchase"
          onClick={() => handleLinkClick("Pricing")}
        >
          Pricing
        </NavLink>

        <NavLink
          className="text-[#1404DA]"
          to="/contact"
          onClick={() => handleLinkClick("Contact")}
        >
          Contact
        </NavLink>

        {!auth?.user ? (
          <>
            <NavLink
              className="text-[#1404DA]"
              to="/login"
              onClick={() => handleLinkClick("Login")}
            >
              Log In
            </NavLink>
            <NavLink
              className="text-red-400"
              to="/signup"
              onClick={() => handleLinkClick("Signup")}
            >
              Sign Up
            </NavLink>
          </>
        ) : (
          <>
            <NavLink
              className="text-[#1404DA]"
              to="/profile"
              onClick={() => handleLinkClick("Profile Dashboard")}
            >
              Dashboard
            </NavLink>
            {(auth?.user?.isAdmin === true ||
              auth?.user?.role === "admin") && (
              <NavLink
                className="text-[#1404DA]"
                to="/admin-dashboard"
                onClick={() => handleLinkClick("Admin dashboard")}
              >
                Admin dashboard
              </NavLink>
            )}
            <NavLink className="text-red-400" onClick={handleLogout}>
              Logout
            </NavLink>
          </>
        )}
      </StyledMenu>
    </>
  );
};

export default BurgerAndMenu;